import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useSelectedWeek} from '../../../../../contexts/SelectedWeekContext'

interface WeekData {
  week: string
  disease: string
  trend: number
  mean: number
  lower: number
  upper: number
  count: number
}

const GoogleTrend: React.FC = () => {
  const [data, setData] = useState<WeekData[]>([])
  //const [allDataMean, setAllDataMean] = useState<WeekData|null>(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const {selectedWeek} = useSelectedWeek('2023-W40')
  const API_URL = process.env.REACT_APP_API_URL
  // const calculateMean = (values) => {
  //   const validValues = values.map(parseFloat).filter((value) => !isNaN(value))
  //   if (validValues.length > 0) {
  //     const sum = validValues.reduce((acc, value) => acc + value, 0)
  //     return sum / validValues.length
  //   } else {
  //     return 0 // Return default value if no valid values found
  //   }
  // }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/googleTrendsRespiratorySyndroms/list?week=${selectedWeek}`
        )
        setData(response.data)
        //const data = response.data // Assuming response.data is an array of objects

        // Calculate mean of the 'mean' values
        // const meanMean =
        //   data.reduce((acc, item) => {
        //     // Convert 'mean' to a number (parseFloat handles conversion of strings to numbers)
        //     const meanValue = parseFloat(item.cases)
        //     if (!isNaN(meanValue)) {
        //       return acc + meanValue
        //     } else {
        //       return acc // Ignore invalid values (NaN)
        //     }
        //   }, 0) / data.length

        // Construct the aggregate object with the computed mean values
        // const aggregatedMeanData = {
        //   week: '',
        //   disease: 'All symptoms',
        //   trend: calculateMean(data.map((item) => item.trend)), // Use a function to calculate trend mean
        //   cases: meanMean,
        // }

        // Update state with aggregated mean data
        //setData(data)
      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data
        setData([])
      }
    }

    fetchData()
  }, [selectedWeek])

  // const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
  //   setPage(newPage)
  // }

  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   setRowsPerPage(parseInt(event.target.value, 10))
  //   setPage(0)
  // }
  const modifiedData = [...data]

  // Find the index where item.disease is "sum"
  const sumIndex = modifiedData.findIndex((item) => item.disease === 'sum')

  // If the item exists and is not already the first item, rearrange
  if (sumIndex > -1) {
    const [sumItem] = modifiedData.splice(sumIndex, 1) // Remove the item
    sumItem.disease = 'All Symptoms'
    sumItem.lower = Number((sumItem.lower / (data.length - 1)).toFixed(2))
    sumItem.mean = Number((sumItem.mean / (data.length - 1)).toFixed(2))
    sumItem.upper = Number((sumItem.upper / (data.length - 1)).toFixed(2))

    // Rename the disease to "All Symptoms"
    modifiedData.unshift(sumItem) // Add it to the beginning
  }
  const interpolateColor = (clampedValue: number): string => {
    // Map value to range [0, 1]
    // const normalizedValue = (value + 90) / 180

    // // Calculate the RGB values for the interpolated color
    // const red = Math.round(normalizedValue * 255)
    // const green = Math.round((1 - normalizedValue) * 255)
    // const blue = 0
    // console.log(`rgb(${red},${green},${blue})`)

    // return `rgb(${red},${green},${blue})`
    if (clampedValue < -15) {
      // Interpoler entre vert (-90) et jaune (0)
      // const ratio = (clampedValue + 90) / 90
      // const red = Math.round(255 * ratio)
      // const green = 255
      // const blue = 0
      // return `rgb(${red},${green},${blue})`
      return 'green'
    } else if (clampedValue > -15 && clampedValue < 15) {
      // Interpoler entre jaune (0) et rouge (90)
      // const ratio = clampedValue / 90
      // const red = 255
      // const green = Math.round(255 * (1 - ratio))
      // const blue = 0
      return `orange`
    }else if (clampedValue > 15) {
      return 'red'
    }else{
      return 'green'
    }
  }
  return (
    <div>
      <div className='card px-4'>
        <div className='card-body row justify-content-md-center'>
          <h2 className='text-primary  p-2 bold' style={{marginBottom: '35px'}}>
            Trend of Google searches reporting respiratory syndromes symptoms (Germany)
            <OverlayTrigger
              placement='right'
              overlay={
                <Tooltip id='logo-tooltip' style={{width: '300px'}}>
                  <p>
                    The table shows the number of normalized Google Trends counts per symptom
                    keyword. Displayed are the top 20 symptoms of respiratory syndromes. For each
                    symptom, the graph shows a trend, calculated as relative slope with 95%
                    Confidence Intervall over the past 5 weeks of Google Trends symptom counts
                    estimated by linear regression. Source: Fraunhofer
                  </p>
                </Tooltip>
              }
            >
              <img
                style={{width: '12px', marginLeft: '10px'}}
                alt='logo'
                src={toAbsoluteUrl('/media/logos/ii.svg')}
              />
            </OverlayTrigger>
          </h2>
          <h4 className='text-center text-gray-800' style={{marginBottom: '30px'}}>
            Google search trends by symptom over the past 5 weeks
          </h4>
          {data.length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      //className='col-4'
                      variant='head'
                      style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}
                    >
                      Symptoms
                    </TableCell>
                    <TableCell
                      className='col-4'
                      variant='head'
                      style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}
                    >
                      Counts
                    </TableCell>
                    <TableCell
                      variant='head'
                      style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}
                    >
                      Mean
                    </TableCell>
                    <TableCell
                      variant='head'
                      style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}
                    >
                      Lower
                    </TableCell>
                    <TableCell
                      variant='head'
                      style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}
                    >
                      Upper
                    </TableCell>
                    <TableCell
                      variant='head'
                      style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}
                    >
                      Trend
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {modifiedData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{textAlign: 'center'}}>{item.disease}</TableCell>
                      <TableCell style={{textAlign: 'center'}}>{item.count}</TableCell>
                      <TableCell style={{textAlign: 'center'}}>
                        {(item.mean / (data.length - 1)).toFixed(2)}
                      </TableCell>
                      <TableCell style={{textAlign: 'center'}}>{item.lower}</TableCell>
                      <TableCell style={{textAlign: 'center'}}>{item.upper}</TableCell>
                      <TableCell style={{textAlign: 'center'}}>
                        <i
                          style={{
                            color: interpolateColor(Number(item.trend)),
                            marginLeft: '10%',
                            fontSize: '20px',
                            transform: `rotate(${-1 * item.trend}deg)`,
                          }}
                          className='fa-solid fa-arrow-right'
                        >
                       
                        </i>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p>We don't have available data for the selected week</p>
          )}

          <p className='card-text source mt-2'>
            <i>
              Source:{' '}
              <a className='fw-bold' href='http://www.fraunhofer.de/en'>
                Fraunhofer
              </a>
              , based on Google searches
            </i>{' '}
          </p>
        </div>
      </div>
    </div>
  )
}

export default GoogleTrend
